var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChairIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chair (1) 1",
    clipPath: "url(#clip0_196_1998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chair",
    d: "M21.2504 21.2498V23.7498C21.2504 25.1304 20.1311 26.2497 18.7505 26.2497H13.7506C12.37 26.2497 11.2507 25.1304 11.2507 23.7498V21.2498M16.2505 26.2497V30.7496M10.0007 30.7496H22.5003M7.9174 11.2501H17.5005M17.5005 1.25037C19.5715 1.25037 21.2504 2.92925 21.2504 5.00026V6.25022H13.7506V5.00026C13.7506 2.92925 15.4295 1.25037 17.5005 1.25037ZM17.5005 1.25037L23.7503 1.25043C25.131 1.25043 26.2502 2.36971 26.2502 3.75036V17.8024M30.0177 21.4822L26.9827 18.4472C25.5667 17.03 23.682 16.25 21.6789 16.25H11.8403C10.8882 16.25 10.0313 15.7202 9.60522 14.8682L5.98714 7.63205C5.36828 6.39915 3.8717 5.89385 2.63274 6.5139C1.3974 7.13157 0.896977 8.63296 1.51458 9.8683L5.13267 17.1044C6.41194 19.6617 8.98268 21.2498 11.8402 21.2498H21.6788C22.3465 21.2498 22.9751 21.5098 23.4476 21.9822L26.4826 25.0172C26.9708 25.5055 27.6105 25.7496 28.2501 25.7496C28.8897 25.7496 29.5294 25.5055 30.0176 25.0172C30.9942 24.0408 30.9942 22.4587 30.0177 21.4822Z",
    stroke: "white",
    strokeWidth: 2.49993,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_1998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChairIcon);
export default __webpack_public_path__ + "static/media/chair-icon.2d82fe4e54980dbac376feb4914d257e.svg";
export { ForwardRef as ReactComponent };